module.exports = __webpack_public_path__ + "img/libya.bea7362c.svg";